import { inject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { AuthService } from "../../services/authService";
import { UserMessageService } from "../../services/userMessageService";
import { CouponWhiteLabelAdminAPI } from "../../services/wladmin/couponWhiteLabelAdminAPI";
import { WhiteLabelAPI } from "../../services/whitelabelAPI";
import { WhiteLabelWhiteLabelAdminAPI } from "../../services/wladmin/whitelabelWhiteLabelAdminAPI";

@inject(
  WhiteLabelAPI,
  WhiteLabelWhiteLabelAdminAPI,
  AuthService,
  Router,
  CouponWhiteLabelAdminAPI,
  UserMessageService
)
export class Subscription {
  constructor(
    whiteLabelAPI,
    whiteLabelAdminAPI,
    authService,
    router,
    api,
    userMessageService
  ) {
    this.saving = false;
    this.router = router;
    this.authService = authService;
    this.api = api;
    this.whitelabelAPI = whiteLabelAPI;
    this.whitelabelAdminAPI = whiteLabelAdminAPI;
    this.userMessageService = userMessageService;
    this.loading = false;
    this.type = "subscribe";
    this.subscriptionType = "STARTER";

    this.monthlyRenewDate = "";
    this.beforeSubType = null;

    this.app_name = window.whitelabel ? window.app_name : "Magnfi";
    this.is_whitelabel = window.whitelabel ? true : false;
    this.sub_error = this.authService.getSubError();
    this.authService.setSubError(null);
    this.showCancelInstructions = false;
    this.isChange = false;

    //Starter
    this.starter_base_fee = 0;
    this.starter_per_user_fee = 0;
    // Unlimited Plan
    this.unlimited_base_fee = 0;
  }

  activate(params) {
    this.loading = true;
    this.loading = true;

    this.load();
  }

  load() {
    this.whitelabelAPI.getWLSignupParams(
      this.apiKeySuccess.bind(this),
      this.saveLoadError.bind(this)
    );

    this.whitelabelAdminAPI.getWhiteLabelData(
      this.authService.getUser().token,
      (data) => {
        console.log("ssscc", data);

        this.starter_base_fee = data.starter_base_fee;
        this.starter_per_user_fee = data.starter_per_user_fee;
        this.unlimited_base_fee = data.unlimited_base_fee;
        this.beforeSubType = data.subscription_plan;
        // this.beforeSubType = "UNLIMITED";
        this.currentSubType = this.beforeSubType;
        this.subscriptionType = this.beforeSubType;
        this.last4 = data.last4;


        this.loading = false;
        this.loading = false;
      },
      () => {}
    );
  }

  apiKeySuccess(
    key,
    redirect_url,
    starter_base_fee,
    starter_per_user_fee,
    unlimited_base_fee,
    recaptcha_site_key
  ) {
    // this.renderStripe(key);

    this.redirect_url = redirect_url;
    this.basicFee = starter_base_fee;
    this.basicPerUserFee = starter_per_user_fee;
    this.unlimitedFee = unlimited_base_fee;
    this.recaptcha_site_key = recaptcha_site_key;
    // this.loading = false;
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError("wlsignup", msg);
    this.loading = false;
    this.saving = false;
  }

  submit() {
    this.loading = true;
    this.saving = true;
    this.whitelabelAdminAPI.updateWlSubscription(
      {
        subscription: this.subscriptionType,
      },
      this.authService.getUser().token,
      (data) => {
        this.userMessageService.setUserMessage(
          "user",
          "Subscription plan is updated!"
        );

        this.beforeSubType=this.subscriptionType;
        this.currentSubType=this.subscriptionType;
        this.loading = false;
        this.saving = false;
      },
      (msg) => {
        this.saveLoadError(msg ? msg : "Server Error!");
      }
    );
  }
  renderStripe(key) {
    // Create a Stripe client
    this.stripe = Stripe(key);

    // Create an instance of Elements
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        lineHeight: "24px",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    };

    // Create an instance of the card Element
    this.card = this.elements.create("card" /*, { style: style }*/);

    // Add an instance of the card Element into the `card-element` <div>
    this.card.mount("#card-element");

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener(
      "change",
      function (event) {
        if (event.error) {
          this.displayError.textContent = event.error.message;
        } else {
          this.displayError.textContent = "";
        }
      }.bind(this)
    );
  }

  change() {
    this.last4 = null;
    this.isChange = true;
  }
}
